import axios, { AxiosResponse } from 'axios'
import { ServiceUnavailable } from 'common/errors/ServiceUnavailable'
import { BaseError } from '../../errors/base-error'

type HttpMethodType = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'

interface RequestOptionsInterface<T> {
  data?: T
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  params?: Record<string, any>
}

const httpClient = axios.create({
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
})

export const websiteHttpClient = async <T, U = unknown>(
  url: string,
  method: HttpMethodType,
  options: RequestOptionsInterface<U> = {},
): Promise<T> => {
  const { data, params } = options
  const response: AxiosResponse<T> = await httpClient({
    method,
    url: `/api/dashboard/website/${url}`,
    data,
    params,
  })
  return response.data
}

export const initializeWebsiteHttpClientInterceptors = () => {
  httpClient.interceptors.response.use(
    response => response,
    error => {
      // TODO: make sure to handle all error cases. Remove unused error cases.
      if (axios.isAxiosError(error) && error.response?.status === 503) {
        throw new ServiceUnavailable(error.response)
      }
      if (axios.isAxiosError(error) && error.response?.data) {
        throw new BaseError(error.response.data)
      }
      throw error
    },
  )
}
